import React, { useEffect, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import { TextField } from "@mui/material";

import Input from "../../../../../stories/Input/Input";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import { Button } from "../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import { Label } from "../../../../../stories/Label/Label";
import TextArea from "../../../../../stories/TextArea/TextArea";
import DeleteModal from "../../../../../customComponents/DeleteModal";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { TableHeaderProps } from "../../../../../utils/types";
import {
  GridAlignment,
  GridCellParams,
  GridColDef,
  GridColumnVisibilityModel,
  GridValidRowModel
} from "@mui/x-data-grid-pro";
import { TABLE_ROW_HEIGHT } from "../../../../../styles/Variables";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import Navbar from "../../../../common/layout/Navbar";
import { LicenseTypes } from "../../../../../utils/Enum.types";
import { useHotKey } from "../../../../../utils/hotKeys";
import { SpecialKeys } from "../../../../../utils/Enum.keys";
import useLabels from "../../../../../customHooks/useLabels";

export const enum PurchaseEntryPageType {
  ADD = "ADD",
  VALIDATE = "VALIDATE"
}
const ValidatePurchaseItem = () => {
  const { Purchase } = useAssetTableJson();
  const navigate = useNavigate();

  const [itemDetails, setItemDetails] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const dynamicHeaders: TableHeaderProps[] = Purchase.Add.filter(
    (header) => header.field !== "actions"
  ).map((header) => {
    return {
      headerName: header.headerName,
      field: header.field,
      cellClassName:header.cellClassName as string,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable
    };
  });
  const columns: GridColDef[] = [...dynamicHeaders];
  const rowData: GridValidRowModel[] = [
    {
      id: 1,
      item_code: "",
      hsn_code: "",
      uom: "",
      rate: "",
      qty: "",
      per_disc_perc: 0,
      prm_disc_amt: 0,
      taxable_rate: 0,
      taxable_value: 0,
      igst: 0,
      sgst: 0,
      cgst: 0,
      tax_amount: 0,
      delivery_charges: 0,
      installation_charges: 0,
      net_value: 0
    }
  ];

  const getRow = () => {
    if (rowData.length) {
      return [
        {
          id: [],
          item_code: [],
          hsn_code: [],
          uom: [],
          rate: "Total",
          qty: 0,
          per_disc_perc: [],
          prm_disc_amt: [],
          taxable_rate: 0,
          taxable_value: 0,
          igst: [],
          sgst: [],
          cgst: [],
          tax_amount: 0,
          delivery_charges: [],
          installation_charges: [],
          net_value: 0
        }
      ];
    }
    return [];
  };

  const pinnedRows = {
    bottom: getRow()
  };

  const getCellClassName = (params: GridCellParams) => {
    const pinnedRowIds = pinnedRows.bottom
      ? pinnedRows.bottom.map((row) => row.id)
      : [];

    const isPinnedRow = pinnedRowIds.includes(params.row.id);

    if (isPinnedRow) {
      switch (params.field) {
        case "net_value":
        case "taxable_rate":
        case "taxable_value":
          return "total-count";
        case "rate":
          return "total";
        case "tax_amount":
          return "balance-count";
        default:
          return "hide-td";
      }
    }

    return "";
  };

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(
      ColumnVisibilityFor.PURCHASE_ENTRY_VALIDATE
    );
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.PURCHASE_ENTRY_VALIDATE,
      JSON.stringify(newModel)
    );
  };

  useHotKey({
    handleFunc: () => {
      setItemDetails(!itemDetails);
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a"
  });

  const { itemLabel, ledgerLabel } = useLabels();

  return (
    <>
      <Navbar NavType={LicenseTypes.COMPANY} />{" "}
      <Title>Validate Purchases</Title>
      <div className="purchase__add">
        <div className="purchase__add--filterblock row g-0">
          <div className="col">
            <TextField
              disabled
              value="6899"
              label={`${ledgerLabel} Name`}
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield"
            />
            <div className="purchase__add--filterblock--flex">
              <TextField
                disabled
                value="6899"
                label="GST No."
                slotProps={{
                  inputLabel: {
                    shrink: true
                  }
                }}
                className="purchase__add--filterblock--textfield"
              />
              <TextField
                disabled
                value="6899"
                label="Mobile No."
                slotProps={{
                  inputLabel: {
                    shrink: true
                  }
                }}
                className="purchase__add--filterblock--textfield"
              />
            </div>
            <TextField
              disabled
              value="6899"
              label="Adress"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield"
            />
          </div>
          <div className="col">
            <TextField
              disabled
              value="6899"
              label="Last Purchased"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield"
            />
            <TextField
              disabled
              value="6899"
              label="Purchased Date"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield"
            />
            <TextField
              disabled
              value="6899"
              label="Balance"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield font-red"
            />
          </div>
          <div className="col">
            <TextField
              disabled
              value="6899"
              label="Last Purchase Order No."
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield"
            />
            <TextField
              disabled
              value="6899"
              label="Last Purchased Date"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield--date"
            />
          </div>
          <div className="col">
            <TextField
              label="Invoice No."
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              disabled
              className="purchase__add--filterblock--textfield"
            />
            <TextField
              label="purchase Type"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              disabled
              className="purchase__add--filterblock--textfield"
            />
            <div className="purchase__add--filterblock--flex">
              <TextField
                label="Entry Bill"
                slotProps={{
                  inputLabel: {
                    shrink: true
                  }
                }}
                disabled
                className="purchase__add--filterblock--textfield"
              />
              <TextField
                label="Type of Bill"
                slotProps={{
                  inputLabel: {
                    shrink: true
                  }
                }}
                disabled
                className="purchase__add--filterblock--textfield"
              />
            </div>
          </div>
          <div className="col">
            <TextField
              label="Invoice Date"
              disabled
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield--date"
            />
            <TextField
              label="Courier"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className="purchase__add--filterblock--textfield"
              disabled
            />
            <TextField
              label="Courier No."
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              disabled
              className="purchase__add--filterblock--textfield"
            />
          </div>
        </div>
        <div className="row g-0 purchase__add--button">
          <div className="col flex-end">
            <Button mode="addnew" onClick={() => setItemDetails(!itemDetails)}>
              {" "}
              {itemLabel}
            </Button>
          </div>
        </div>
        <div className="purchase__add--tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rowData}
            rowHeight={TABLE_ROW_HEIGHT}
            disableRowSelectionOnClick
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
            initialState={{
              columns: {
                columnVisibilityModel: columnVisibilityModel
              }
            }}
            hideFooter
            pinnedRows={pinnedRows}
            getCellClassName={getCellClassName}
          />
        </div>
        <div className="purchase__add--datablock">
          <div className="purchase__add--datablock--left">
            <div className="label-grid">
              <Label>Entered By</Label>
              <Input disabled />
              <Label>Validated By</Label>
              <Input disabled /> <Label>Stock Checked By</Label>
              <Input disabled />
              <Label>Narration</Label>
              <TextArea rows={4} disabled />
            </div>
          </div>
          <div className="purchase__add--datablock--right">
            <div className="purchase__add--datablock--right--flex">
              <Label>Total Delivery Charges :</Label>
              <Input disabled value="0" />
            </div>
            <div className="purchase__add--datablock--right--flex">
              <Label>Total Installation Charges :</Label>
              <Input disabled value="0" />
            </div>
            <div className="purchase__add--datablock--right--flex">
              <Label>Secondary Discount Amount :</Label>
              <Input className="font-red" disabled value="0" />
            </div>
            <div className="purchase__add--datablock--right--flex">
              <Label>Freight / Extra Charges :</Label>
              <Input className="font-amber" disabled value="0" />
            </div>
            <div className="purchase__add--datablock--right--flex">
              <Label>Net Amount :</Label>
              <Input className="total-count" disabled value="0" />
            </div>
          </div>
        </div>
        <Button mode="approve" />
        <Button mode="reject" />
        <Button mode="clear" />
        <Button mode="back" onClick={() => navigate(-1)} />
      </div>
      {/* <CustomModal
        isOpen={itemDetails}
        onRequestClose={() => setItemDetails(!itemDetails)}
        contentComponent={<PurchaseItem setModalFlag={setItemDetails} />}
        style={AddModalStyles}
      /> */}
      <DeleteModal
        id={0}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        // handleDelete={HandleDelete}
      />
    </>
  );
};

export default ValidatePurchaseItem;
